/**
 * Environment configuration for the Sencha Tea Shop application.
 * Values are injected dynamically during build/serve via Webpack DefinePlugin.
 * See `webpack.config.js` and `.env` for the variables passed through `process.env`.
 */
declare const process: { env: Record<string, string | undefined> };

export const environment = {
  version: '0.0.0', // This is typically overridden by semantic-release in CI
  gitCommit: 'unknown',
  sentryEnvironment: process.env['TEA_SHOP_FE_SENTRY_ENVIRONMENT'] || 'development',
  apiHost: coerceEmptyStringToNull(process.env['TEA_SHOP_FE_API_HOST'] || ''),
  enableImageTransforms: coerceStringToBoolean(process.env['TEA_SHOP_FE_ENABLE_IMAGE_TRANSFORMS'] || 'false'),
  production: compareStringEquality(process.env['TEA_SHOP_FE_SENTRY_ENVIRONMENT'] || 'development', 'production'),
  stripePublishableKey: process.env['TEA_SHOP_FE_STRIPE_PUBLIC_KEY'] || 'pk_test_51Qd0QY2NnarlrS83PnIbVIZGe9SRCh5jIPQX7fOI1jn87FvmoZEkBRDdRcjdmF1ZOoa6E8euLLlHDmFFHhjkDS1800qoSPT3dZ',
  transformPrefix: coerceEmptyStringToNull(process.env['TEA_SHOP_FE_TRANSFORM_PREFIX'] || ''),
  contactUsWorkflowUrl: process.env['TEA_SHOP_FE_CONTACT_US_WORKFLOW_URL'] || 'https://n8n.truetea.link/webhook/79d10f9a-6e45-471d-890d-983b1ae58718',
  OPTIMISATION_GA: coerceEmptyStringToNull(process.env['TEA_SHOP_FE_OPTIMISATION_GA'] || ''),
  OPTIMISATION_CLARITY: coerceEmptyStringToNull(process.env['TEA_SHOP_FE_OPTIMISATION_CLARITY'] || ''),
  OPTIMISATION_OPEN_REPLAY: coerceEmptyStringToNull(process.env['TEA_SHOP_FE_OPTIMISATION_OPEN_REPLAY'] || ''),
  GOOGLE_MAPS_API_KEY: process.env['TEA_SHOP_FE_GOOGLE_MAPS_API_KEY'] || 'AIzaSyCx-fpUmsENUkyGk4jDs_J0hpExiuCsWnc',

  // https://github.com/dbfannin/ngx-logger/blob/master/src/lib/types/logger-level.enum.ts
  LOGGER_LEVEL: parseInt(process.env['TEA_SHOP_FE_LOGGER_LEVEL'] || '4') || 2, // Default to INFO level
};

/* Configuration for GrowthBook */

import { Context, InitOptions } from '@growthbook/growthbook';

export const growthBookContext: Context = {
  apiHost: process.env['TEA_SHOP_FE_GROWTHBOOK_API_HOST'] || 'https://gbproxy.truetea.link',
  clientKey: process.env['TEA_SHOP_FE_GROWTHBOOK_CLIENT_KEY'] || 'sdk-2FvRpGXccRVHfizK',
  enableDevMode: coerceStringToBoolean(process.env['TEA_SHOP_FE_GROWTHBOOK_ENABLE_DEV_MODE'] || 'true'),
};

export const growthBookInitOptions: InitOptions = {
  streaming: coerceStringToBoolean(process.env['TEA_SHOP_FE_GROWTHBOOK_STREAMING'] || 'true'),
  timeout: parseInt(process.env['TEA_SHOP_FE_GROWTHBOOK_TIMEOUT'] || '2000') || 2000,
  skipCache: coerceStringToBoolean(process.env['TEA_SHOP_FE_GROWTHBOOK_SKIP_CACHE'] || 'true'),
};

function coerceStringToBoolean(value: string): boolean {
  if (!value) return false;
  value = value.toLowerCase();
  return value === 'true' || value === '1' || value === 'yes';
}

function coerceEmptyStringToNull(value: string): string | null {
  return !value || value === '' ? null : value;
}

function compareStringEquality(a: string, b: string): boolean {
  if (!a || !b) return false;
  return a.toLowerCase() === b.toLowerCase();
}